import { NavigateFunction } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { ROUTES } from '../constants/navigation.constants';
import { CommonAuthService, i18n } from '@umanforge/common';
import { GlobalService } from './global.service';
import { Dispatch } from '@reduxjs/toolkit';
import { ConfirmNavModal } from 'components/modals/confirm_nav_modal.component';
import { ChartIcon } from '@common_components/icons/chart.icon';
import { DisconnectIcon } from '@common_components/icons/disconnect.icon';
import { GearIcon } from '@common_components/icons/gear.icon';
import { PlaniteamIcon } from 'components/icons/planiteam.icon';
import { ChronogramIcon } from 'components/icons/chronogram.icon';
import { TimeGridIcon } from 'components/icons/timegrid.icon';
//import { CalendarIcon } from '@common_components/icons/calendar.icon';


interface NavBarItems {
  text: string,
  logo: JSX.Element;
  link?: string;
  onClick?: () => void;
}
export class NavigationService {
  static getNavBarItems( token: string | null, dispatch: Dispatch, t: ( str: string ) => string, user: {
    isSuperAdmin: boolean;
    isAdminOfUser: boolean;
    clients: Array<{
      id: string;
      isAdmin: boolean;
      sites: Array<{
        id: string;
        isAdmin: boolean;
        sectors: Array<{ id: string; isAdmin: boolean }>;
      }>;
    }>;
  }, currentClientId: string, currentSiteId: string, currentSectorId: string ) {
    const isAdmin = user.isSuperAdmin || user.isAdminOfUser ||
      user.clients.some( client => {
        return ( client.isAdmin && client.id === currentClientId ) ||
          client.sites.some( site => {
            return ( site.isAdmin && site.id === currentSiteId ) ||
              site.sectors.some( sector => {
                return sector.isAdmin && sector.id === currentSectorId;
              } );
          } );
      } );

    const items: NavBarItems[] = [
      {
        text: t( 'translation:home' ),
        logo: <PlaniteamIcon size={ 10 } className='fill-app-color -mx-2'/>,
        link: ROUTES.HOME,
      },
      {
        text: t( 'translation:chronogram' ),
        logo: <ChronogramIcon size={ 10 } className='fill-app-color -mx-2'/>,
        link: ROUTES.CHRONOGRAM,
      },
    ];

    if ( isAdmin ) {
      items.push(
        {
          text: t( 'common:settings' ),
          logo: <GearIcon size={ 9 } className=" fill-app-color -mx-1.5"/>,
          link: ROUTES.SETTING,
        },
        {
          text: t( 'translation:statistics' ),
          logo: <ChartIcon size={ 10 } className='fill-app-color -mx-1.5'/>,
          link: ROUTES.CHART,
        },
        {
          text: t( 'translation:timegrid' ),
          logo: <TimeGridIcon size={ 10 } className='fill-app-color -mx-1.5'/>,
          link: ROUTES.TIMEGRID,
        }
        // {
        //   text: 'Data',
        //   logo: <GearIcon size={ 9 } className=" fill-app-color -mx-1.5"/>,
        //   link: '/data',
        // }
      );
    }

    items.push( {
      text: t( 'common:disconnect' ),
      logo: <div className="h-7 w-7 fill-blue-800"><DisconnectIcon/></div>,
      onClick: async () => {
        await CommonAuthService.signOutUser( token, dispatch, GlobalService.onAxiosWarning, err => { GlobalService.onAxiosError( err, dispatch ); } );
      },
    } );
    return items;
  }

  static toHome( navigate: NavigateFunction, needConfirmation: boolean ) {
    NavigationService.navigateTo( ROUTES.HOME, needConfirmation, navigate );
  }

  static navigateTo( path: string, needConfirmation: boolean, navigate: NavigateFunction ) {
    if ( NavigationService.isValidNavigation( path ) ) {
      if ( needConfirmation ) {
        NavigationService.openConfirmModal( path, navigate );
      } else {
        navigate( path );
      }
    }
  }

  private static isValidNavigation( path: string ) {
    return path != window.location.pathname;
  }

  private static openConfirmModal( path: string, navigate: NavigateFunction ) {
    const root = ( document.getElementById( 'root' ) as HTMLElement );
    ReactDOM.hydrateRoot(
      root,
      <ConfirmNavModal
        onConfirm={ () => { NavigationService.navigateTo( path, false, navigate ); } }
        onClose={ () => { ; } }
        t={ i18n.t }
      />
    );
  }

};